import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';
import LoadUnitItemService from '../services/LoadUnitItemService';
import UnitItemHistoryScene from './unit-item/UnitItemHistoryScene';
import MasteryTestItemHistoryScene from './mastery-test-item/MasteryTestItemHistoryScene';
import CertificationTestItemHistoryScene from './certification-test-item/CertificationTestItemHistoryScene';
import PlacementTestItemHistoryScene from './placement-teste-item/PlacementTestItemHistoryScene';
import LoadMasteryTestItemService from '../services/LoadMasteryTestItemService';
import LoadCertificationTestItemService from '../services/LoadCertificationTestItemService';
import LoadPlacementTestItemService from '../services/LoadPlacementTestItemService';
import { toJS } from 'mobx';

class ItemHistorySceneContainer extends Component {
  static propTypes = {
    params: PropTypes.shape({
      moduleId: PropTypes.string,
      unitId: PropTypes.string,
      masteryTestId: PropTypes.string,
      certificationTestId: PropTypes.string,
      placementTestId: PropTypes.string,
      itemId: PropTypes.string.isRequired,
    }).isRequired,
  };

  componentWillMount() {
    if (this.props.params.itemId) {
      if (this.props.params.moduleId && this.props.params.unitId) {
        this.service = new LoadUnitItemService();
        this.service.handleLoad(this.props.params.moduleId, this.props.params.unitId, this.props.params.itemId);
      }
      if (this.props.params.moduleId && this.props.params.masteryTestId) {
        this.service = new LoadMasteryTestItemService();
        this.service.handleLoad(this.props.params.moduleId, this.props.params.masteryTestId, this.props.params.itemId);
      }
      if (this.props.params.certificationTestId) {
        this.service = new LoadCertificationTestItemService();
        this.service.handleLoad(this.props.params.certificationTestId, this.props.params.itemId);
      }
      if (this.props.params.placementTestId) {
        this.service = new LoadPlacementTestItemService();
        this.service.handleLoad(this.props.params.placementTestId, this.props.params.itemId);
      }
    }
  }

  render() {
    if (this.service.unitItem) {
      return <UnitItemHistoryScene unitItem={toJS(this.service.unitItem)} fetching={this.service.fetch.fetching} />;
    }
    if (this.service.masteryTestItem) {
      return (
        <MasteryTestItemHistoryScene
          masteryTestItem={toJS(this.service.masteryTestItem)}
          fetching={this.service.fetch.fetching}
        />
      );
    }
    if (this.service.certificationTestItem) {
      return (
        <CertificationTestItemHistoryScene
          certificationTestItem={toJS(this.service.certificationTestItem)}
          fetching={this.service.fetch.fetching}
        />
      );
    }
    if (this.service.placementTestItem) {
      return (
        <PlacementTestItemHistoryScene
          placementTestItem={toJS(this.service.placementTestItem)}
          fetching={this.service.fetch.fetching}
        />
      );
    }
    return null;
  }
}

export default observer(ItemHistorySceneContainer);
